import React from "react";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import * as style from "./Cover.module.scss";
import logo from "../../assets/img/logo.png";
import behance from "../../assets/img/icon/behance.png";
import mail from "../../assets/img/icon/mail.png";

const Cover = React.forwardRef((props, ref) => (
  <div ref={ref} className={style.root}>
    <Col
      className="d-flex flex-column align-content-center justify-content-center h-100 cover-wrapper"
      xs={12}
    >
      <div className="d-flex justify-content-center">
        <img src={logo} height="121" width="101" />
      </div>
      <div className="cover-buttons-wrapper">
        <a
          href="https://firebasestorage.googleapis.com/v0/b/paula-86679.appspot.com/o/pdf%2FCV%20-%20Paula%20Go%CC%81mez%20de%20la%20Torre.pdf?alt=media&token=5f0304f0-d62a-496d-b797-824f1148b58f"
          target="_blank"
        >
          <button className="resume-button p-2 w-100">CV - Resume</button>
        </a>
        <a
          href="https://firebasestorage.googleapis.com/v0/b/paula-86679.appspot.com/o/pdf%2FPortafolio%20-%20Ilustraciones.pdf?alt=media&token=32c185cb-c704-4f39-a347-ca7a7b96a728"
          target="_blank"
        >
          <button className="resume-button p-2 w-100">
            Illustration Portfolio
          </button>
        </a>

        <a
          href="https://firebasestorage.googleapis.com/v0/b/paula-86679.appspot.com/o/video%2FPaula%20G%C3%B3mez%20de%20la%20Torre%202022-_3%20(1).mp4?alt=media&token=7cccc275-2e44-4c71-b272-2e076173f09c"
          target="_blank"
        >
          <button className="resume-button p-2 w-100">Animation Reel</button>
        </a>
      </div>
      <div className="d-flex justify-content-center contact-wrapper">
        <a href="https://www.behance.net/Paulagtr" target="_blank">
          <img src={behance} height="90%" />
        </a>
        <a href="mailto:paula.gomezdelatorrer@gmail.com">
          <img src={mail} height="90%" />
        </a>
      </div>
    </Col>
  </div>
));

export default Cover;
